import { getCropCssColor } from "@omnia/shared/fields";
import { FieldViewModel, ICrop } from "../../../omnia";

import { groupBy } from "@omnia/shared/utils/array";

export class CroppingGroupLiteVm {

    public headerText: string;

    public crop: ICrop

    public order: number;

    public constructor(public cropping: FieldViewModel[]) {
    }

    getSingleCropColor() {
        if (this.crop) {
            return getCropCssColor(this.crop);
        }
    }

    static groupByVariety(cropping: FieldViewModel[]): CroppingGroupLiteVm[] {

        cropping = cropping.filter(c => !!c.cropId)

        var groups = groupBy(cropping,
            c => ({ crop: c.cropping.Crop, variety: c.cropping.Variety }),
            c => {
                return c.crop.CropId.toString() + (c.variety ? ":" + c.variety.CropVarietyId.toString() : "");
            });

        var vm = groups.map(g => {

            var croppingGroup = g.values;

            var group = new CroppingGroupLiteVm(croppingGroup);

            group.headerText = g.key.crop.Name + (g.key.variety ? " / " + g.key.variety.Name : "");
            group.crop = g.key.crop;

            return group;

        });

        vm = vm.sort((g1, g2) => {

            var r = g1.order - g2.order;
            if (r) return r;

            return (g1.headerText || "").localeCompare(g2.headerText || "");

        });


        return vm;

    }
}
